import { render } from "./AdFormatFilter.vue?vue&type=template&id=e36adfca"
import script from "./AdFormatFilter.vue?vue&type=script&lang=js"
export * from "./AdFormatFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__